var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","viewBox":"0 0 24 24"}},[_c('line',{attrs:{"x1":"18","y1":"6","x2":"6","y2":"18"}}),_c('line',{attrs:{"x1":"6","y1":"6","x2":"18","y2":"18"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }